/**
 * Each special's effect in plain words, for the back of the full-size card
 * (SpecialCardViewer). Short enough to read at a glance; the full rules are
 * SPECIAL_CARD_INFO's descriptions (shared), which these follow.
 */

import type { SpecialCardType } from '@pokercubed/shared';

export const SPECIAL_CARD_TEXT: Record<SpecialCardType, string> = {
  chameleon: 'Its jewel stays open until the showdown, then becomes whichever jewel gives you the best hand.',
  numerology: 'Takes the rank of your other hole card. Keeps its own suit and jewel.',
  suitor: 'Takes the suit of your other hole card. Keeps its own rank and jewel.',
  jeweler: 'Takes the jewel of your other hole card. Keeps its own rank and suit.',
  impersonator: 'Becomes an exact copy of the centre card once it turns over.',
  anchor: 'Your hand can use L-shaped lines as well as the rows and columns — but not the diagonals.',
  highflyer: 'On every line, becomes the highest rank on that line. Keeps its own suit and jewel.',
  oracle: 'After the diamond turns, see the rank and suit of every opponent’s hole cards.',
  seer: 'See the centre card as soon as the corners turn — before anyone else.',
  thief: 'After the diamond turns, takes the rank of the diamond card that helps your hand most. Locked in: the centre can’t change it.',
  joker: 'Its suit stays open until the showdown, then becomes whichever suit gives you the best hand.',
  soothsayer: 'After the diamond turns, see the suit and jewel of every opponent’s hole cards.',
  spy: 'After the diamond turns, see which special card each opponent holds.',
  omnipotent: 'After the diamond turns, see every opponent’s hole cards in full.',
  ghost: 'Its rank counts for nothing — it can’t pair up or help a straight.',
  orphan: 'Its suit counts for nothing — it can’t help a flush.',
  void: 'Its jewel counts for nothing — it can’t help your Best Color.',
  crossed: 'Your hand can’t use the two diagonals — only the 3 rows and 3 columns.',
  limbo: 'Once the centre turns, becomes the lowest rank not on the matrix, in the suit and jewel the matrix has least of.',
  snare: 'Your best line for Best Hand is taken away — you play your next best.',
  flawed: 'Your best line for Best Color is taken away — you play your next best.',
  fray: 'The line with the most cards of one suit is taken away from your Best Hand.',
  prank: 'Its rank is hidden from you until the showdown. It still counts in full.',
  blind: 'Its suit is hidden from you until the showdown. It still counts in full.',
  buried: 'Its jewel is hidden from you until the showdown. It still counts in full.',
  origami: 'You can’t fold this hand — check, call or raise.',
  hellraiser: 'You can’t check or call this hand — raise or fold.',
  commentator: 'You can’t raise this hand — check, call or fold.',
};
